const TEXT =
  "CREAZIONE SITO • GESTIONE H24 • OTTIMIZZAZIONE SEO • PERFORMANCE ACCELERATA • ASSISTENZA DEDICATA • DESIGN EDITORIALE • ";

export default function Marquee() {
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden bg-[#F3F0EA] border-y border-black/10 py-4"
      aria-hidden="true"
    >
      <div className="animate-marquee flex whitespace-nowrap w-max">
        {[0, 1].map((n) => (
          <span key={n} className="mono-label text-neutral-600 text-xs sm:text-sm pr-2">
            {TEXT.repeat(3)}
          </span>
        ))}
      </div>
    </div>
  );
}
